<template>
  <BaseCard :selected="selected">
    <Flex direction="column">
      <Flex
        align="center"
        justify="between"
      >
        <BaseRadio
          :modelValue="selected ? 'enabled' : 'disabled'"
          :disabled="disabled"
          :options="[{ label, value: 'enabled' }]"
          @update:modelValue="handleSelect"
        />
        <slot name="right" />
      </Flex>
      <slot />
    </Flex>
  </BaseCard>
</template>

<script
  setup
  lang="ts"
>
withDefaults(
  defineProps<{
    disabled: boolean;
    label: string;
    selected: boolean;
  }>(),
  {
    disabled: false,
    label: '',
    selected: false,
  },
);

const emit = defineEmits(['update:selected']);

const handleSelect = (value: string) => {
  emit('update:selected', value === 'enabled');
};
</script>
